import { render, staticRenderFns } from "./DiscountsList.vue?vue&type=template&id=9af3c5c4&scoped=true&"
import script from "./DiscountsList.vue?vue&type=script&lang=js&"
export * from "./DiscountsList.vue?vue&type=script&lang=js&"
import style0 from "./DiscountsList.vue?vue&type=style&index=0&id=9af3c5c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9af3c5c4",
  null
  
)

export default component.exports